import { getFeatureFlag } from 'src/app/core/services/feature-flag-helpers';
import { EFeatureFlag } from 'src/app/core/services/feature-flags-consts';
import { TWhiteLabel } from '../white-label.model';
import { hasCustomColors } from './has-custom-colors';
import { DEFAULT_ORIGINAL_PANEL_COLORS, DEFAULT_PANEL_COLORS } from './white-label-defaults.const';

export function resolveIconActiveColorPanel(whiteLabelData: TWhiteLabel): string {
  if (whiteLabelData.iconActiveColorPanel) {
    return whiteLabelData.iconActiveColorPanel;
  }

  if (!getFeatureFlag(EFeatureFlag.REBRAND)) {
    return DEFAULT_ORIGINAL_PANEL_COLORS.iconActiveColorPanel;
  }

  if (hasCustomColors(whiteLabelData)) {
    return DEFAULT_ORIGINAL_PANEL_COLORS.iconActiveColorPanel;
  }

  return DEFAULT_PANEL_COLORS.iconActiveColorPanel;
}
